import MultChoiceObj from "../Models/QTypes/MultChoiceObj";
// import CheckboxObj from '../Models/QTypes/CheckboxObj';

const IT_QSet = [
  new MultChoiceObj({
    questionSet: {
      English:
        "Which best describes how you leverage predictive analytics for HR today?",
    },
    answerSet: {
      English: [
        "We perform basic (historical/transactional) HR reporting without predictive analysis.",
        "Ad hoc predictive modeling conducted as needed in spreadsheets.",
        "Predictive analysis with modeling done in a stand-alone analytics system.",
        "Predictive modeling capabilities are integrated within BI & Analytics systems.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English: "How do you forecast labor availability?",
    },
    answerSet: {
      English: [
        "We use spreadsheets to track availability and absences.",
        "Labor forecasts are in standard shared BI reports.",
        "Partially integrated forecasting done in dashboards based on past trend",
        "Fully streamlined labor forecasting with predictive analytics and what-if scenario modeling.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English: "What is your company’s approach to cloud adoption for HR?",
    },
    answerSet: {
      English: [
        "We use only on-premises solutions for HR reporting.",
        "Cloud used in some departments, but we are examining how it can support our HR strategies.",
        "We have a standalone cloud provider for HR disconnected from corporate strategy.",
        "Cross functional corporate strategy includes HR systems processes and analytic reporting.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English:
        "How do you tie HR metrics to larger business and financial strategy?",
    },
    answerSet: {
      English: [
        "We combine Finance and HR data with a manual process in spreadsheets.",
        "Standard BI reporting but our systems aren't integrated.",
        "Both Finance and HR data is displayed in our strategy dashboards.",
        "Analytics system leverages enterprise-wide HR and Finance data for better strategy execution.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English: "How do you enrich your HCM data with external data?",
    },
    answerSet: {
      English: [
        "We do not include external HR data today in our HR reporting.",
        "We leverage spreadsheets to bring together some external HR data.",
        "Our analytics system allows for ad hoc integration of HCM data with external data.",
        "External data is easily embedded with native connectors to extend our performance metrics in Analytics.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English: "How would you describe your HR data preparation process?",
    },
    answerSet: {
      English: [
        "A tedious, manual ETL process reliant on spreadsheets, completed by IT.",
        "Less manual, top-down process from IT with little input from affected HR departments.",
        "HR changes documented and standardized by IT, with some input from HR department teams.",
        " Enterprise-wide HR data management that’s integrated and on demand for any level of user.",
      ],
    },
  }),
];

export default IT_QSet;
